import { render, staticRenderFns } from "./IconSvgPROLEGISMyProlegis.vue?vue&type=template&id=b138f94c&scoped=true&"
import script from "./IconSvgPROLEGISMyProlegis.vue?vue&type=script&lang=js&"
export * from "./IconSvgPROLEGISMyProlegis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b138f94c",
  null
  
)

export default component.exports